<template>
  <div class="page-content campus-list">
    <transition name="default" mode="out-in">
      <router-view :key="$route.path"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import aliOSS from 'ali-oss'

export default {
  data() {
    return {
      // searchModel: '', //搜索学习中心

      tableLoading: false,
      dataSource: [],
      selectedRowKeys: [],
      total: 0,
      current: 1,
      // aliOSS实例
      aliOSSClient: null,
      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 }
      },
      uploadLoading: false,
      searchValue: '',
      selectedRowKeys: [],
      pageSize: 20,
      total: 0,
      current: 1,
      approvalList: [],
      MatchList: [],
      matchType: 0,
      MatchListLoading: true
    }
  },

  props: {
    updateComponent: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters(['handleRightsList', 'sidebarRouterList'])
  },

  watch: {
    updateComponent() {
      this.handleSearch()
    },
    searchValue(val) {
      this.getMatchSList(this.matchType, val)
    }
  },

  created() {
    // this.getMatchSList(this.matchType, '')
  },
  methods: {
    changeTab(key) {
      this.getMatchSList(key, '')
    },
    showModalAddList() {
      this.modalVisible = true
    },
    handleOkAddList() {
      this.modalVisible = false
    },
    getMatchSList(matchType, matchName) {
      this.matchType = matchType
      let data = {
        matchType,
        pageNum: this.current,
        pageSize: this.pageSize,
        matchName
      }
      this.$http(this.$api.QUERYMATCHLIST, data).then(r => {
        console.log(r)
        this.MatchList = r.data.records
        this.total = r.data.total
        this.MatchListLoading = false
        // this.addApplyListForm.resetFields()
        // this.$notification.open({
        //   type: 'success',
        //   message: '添加申请条件',
        //   description: '添加成功'
        // })
      })
    },
    btnrouter() {
      this.$router.push('matchList')
      // this.$router.push(item.name)
    },
    // 分页
    currentChange(val) {
      this.current = val
      this.getDataSource()
    }
  }
}
</script>
<style scoped lang="less">
.page-content {
  width: 100%;
  height: 100%;
  .header {
    width: 100%;
    height: 60px;
    padding-right: 20px;
    box-sizing: border-box;
    .ser {
      float: left;
    }
    .ser:last-child {
      float: right;
    }
  }
  .navList {
    width: 100%;
  }
  /deep/ .ant-table-tbody {
    /deep/ .border {
      position: relative;
      top: -0.06em;
      display: inline-block;
      width: 1px;
      height: 0.9em;
      margin: 0 8px;
      vertical-align: middle;
      background-color: #e8e8e8;
    }
  }
}
/deep/ .ant-modal-body {
  /deep/ .tableBox {
    width: 100%;
    height: 100%;
    .header {
      width: 100%;
      height: 60px;
      .ser {
        float: left;
        width: 50%;
      }
      .ser:last-child {
        .ant-btn {
          float: right;
        }
      }
    }
  }
  /deep/ .border {
    position: relative;
    top: -0.06em;
    display: inline-block;
    width: 1px;
    height: 0.9em;
    margin: 0 8px;
    vertical-align: middle;
    background-color: #e8e8e8;
  }
  /deep/ .ant-upload-list-item-card-actions {
    display: none;
  }
}
</style>
